import axios from 'axios';
import { reportToBugsnag } from '../utilities/bugsnag-helper';

const ApiService = {
    createApiInstance(token, { enableBugsnag = false } = {}) {
        const apiInstance = axios.create({
            baseURL: process.env.VUE_APP_API,
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        apiInstance.interceptors.response.use(
            response => response,
            error => {
                const globalOptIn = enableBugsnag;
                const config = error.config || {};
                const perRequestOptIn = config.useBugSnag === true;
                const shouldNotify = perRequestOptIn || globalOptIn;

                if (shouldNotify) {
                    reportToBugsnag(error);
                }

                return Promise.reject(error);
            },
        );

        return {
            get(resource, config = {}) {
                return apiInstance.get(resource, config);
            },

            post(resource, data, config = {}) {
                return apiInstance.post(resource, data, config);
            },

            put(resource, data, config = {}) {
                return apiInstance.put(resource, data, config);
            },

            delete(resource, config = {}) {
                return apiInstance.delete(resource, config);
            },
        };
    },
};

export default ApiService;
